import { render } from "./transaction_details.vue?vue&type=template&id=25bd172c"
import script from "./transaction_details.vue?vue&type=script&lang=js"
export * from "./transaction_details.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__